import { applicationApi } from "../../common/api";
import { Gallery, GalleryItem } from "./types";

// Define a service using a base URL and expected endpoints
export const galleryApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllGallery: builder.query<Gallery[], void>({
      query: () => `gallery`,
      providesTags: [{ type: "Gallery", id: "LIST" }],
    }),
    getGallery: builder.query<Gallery, string>({
      query: (query) => `gallery/${query}`,
      providesTags: [{ type: "Gallery", id: "SINGLE" }],
    }),
    createGallery: builder.mutation<Gallery, any>({
      query: (body) => ({
        url: "/gallery",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Gallery", id: "LIST" }],
    }),
    deleteGallery: builder.mutation<any, number>({
      query: (id) => ({
        url: `gallery/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Gallery", id: "LIST" }],
    }),
    updateGallery: builder.mutation<Gallery, any>({
      query: (body) => ({
        url: "/gallery",
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "Gallery", id: "LIST" }],
    }),
    createGalleryItem: builder.mutation<GalleryItem, any>({
      query: (body) => ({
        url: "/gallery/item",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Gallery", id: "SINGLE" }],
    }),
    deleteGalleryItem: builder.mutation<any, number>({
      query: (id) => ({
        url: `gallery/item/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Gallery", id: "SINGLE" }],
    }),
    updateGalleryItem: builder.mutation<GalleryItem, any>({
      query: (body) => ({
        url: "/gallery/item",
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "Gallery", id: "SINGLE" }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllGalleryQuery,
  useGetGalleryQuery,
  useCreateGalleryMutation,
  useDeleteGalleryMutation,
  useUpdateGalleryMutation,
  useDeleteGalleryItemMutation,
  useCreateGalleryItemMutation,
  useUpdateGalleryItemMutation,
} = galleryApi;
